import React from "react";

import { StoreAdminNavigationScreenProps } from "../StoreAdmin/StoreAdminNavigation";
import { LazyQueryNetworkBoundrary } from "../../components/mobile/QueryNetworkBoundrary";
import { IntegrationBokaklipp } from "./IntegrationBokaklipp";
import { IntegrationFlourish } from "./IntegrationFlourish";
import { IntegrationPushAppy } from "./IntegrationPushAppy";

export function IntegrationScreen(
  props: StoreAdminNavigationScreenProps<"Integration">
) {
  return (
    <LazyQueryNetworkBoundrary>
      {(fetchKey) => <InnerIntegrationScreen {...props} fetchKey={fetchKey} />}
    </LazyQueryNetworkBoundrary>
  );
}

function InnerIntegrationScreen(
  props: StoreAdminNavigationScreenProps<"Integration"> & {
    fetchKey: string;
  }
) {
  switch (props.route.params.type) {
    case "flourish":
      return (
        <IntegrationFlourish
          onCompleted={props.navigation.goBack}
          mode={props.route.params.mode}
        />
      );
    case "bokaklipp":
      return (
        <IntegrationBokaklipp
          onCompleted={props.navigation.goBack}
          mode={props.route.params.mode}
        />
      );
    case "pushappy":
      return (
        <IntegrationPushAppy
          onCompleted={props.navigation.goBack}
          mode={props.route.params.mode}
        />
      );
  }
  return null;
}
